import { ActionReference, DefaultGameState, GameObjectReference, GameState } from "@shared/types";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { Page } from "../enums/Page";

/** CSS affecting the {@link CanvasComponent} */
const styles: string = css`
    :host {
        font-family: "Onesize";
        max-width: 1024px;
        height: 100%;
        width: 100%;
    }

    .inventory {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 100px; /* Move inventory down */
    left: 100px; /* Move inventory to the left */
    display: grid; /* Ensure grid layout works */
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    
    
}
    .inventory > .inventory-header {
        background-color: #780606;
        padding: 5px 10px;
        display: inline-block; 
        border: 10px solid #4D0404   
    }
    
    .inventory > .inventory-items {
        background-color: #666666;
        border: 1px solid #6d6d6d;
        padding: 5px 10px;
        height: 300px;
        overflow-y: auto;
        display: inline-block;
        border: 10px solid #4e4e4e     ;

    }
    .inventory > .inventory-header,
.inventory > .inventory-items {
    display: block; /* Ensures proper stacking */
    width: 300px /* Makes them full-width */
}
 
    .canvas {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }

    .title {
        text-align: center;
        margin-top: 10px;
        overflow: auto;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 10px;
        
    }

    .header img {
        width: 570px;
        height: 570px;
        image-rendering: pixelated;
        display: auto;
        margin-bottom: 100px;
    }

    .header img:nth-child(n + 2) {
        position: absolute;
    }

    .content {
        overflow: auto;
        margin-top: auto;
        padding: 1 10px;
        text-align: justify;
        z-index: 1;
        background-color: #666666 ;
        opacity: 0.9;
        border: 10px solid #4e4e4e     ;
        display: inline-block;  

    }

    .content p {
        font-size: 20px;
        margin: 0 0 10px 0;  

    }

    .content p:last-of-type {
        margin: 0;
    }

    .footer {
        border-radius: 10px 10px 0 0;

        margin-top: 10px;
        display: flex;
        height: auto;
        min-height: 105px;
        max-height: 200px;
    }

    .footer .buttons {
        display: flex;
        flex: 1;
        max-height: 500px;
        flex-direction: column;
        overflow: auto;
        padding: 10px 10px 0 10px;
        z-index: 1;
    }

    .footer .button {
        background-color: #780606;
        border: 1px solid #6d6d6d;
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        
    }

    .footer .button.active,
    .footer .button:hover {
        background-color: #bebbbb;
        color: #000000
    }

.notebook-button-container {
    position: absolute;
    top: 50px;
    right: 300px;
    display: flex;
    flex-direction: column;
    gap: 10px; 
    display: flex;
    flex-direction: column;
    gap: 10px; 
}



    .button {
    color: #ffffff;
    background-color: #780606;
    border: 1px solid #6d6d6d;
    padding: 15px 20px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block;
    user-select: none;
}

.map-button-container {
        position: absolute;
        top: 50px;
        right: 450px;
    }

    .button {
        background-color: #780606;
        border: 1px solid #6d6d6d;
        padding: 15px 20px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
    }



    #logout-button {
    background-color: #780606;
    border: 1px solid #6d6d6d;
    padding: 5px 10px;
    margin: 10px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block;
    user-select: none;
    font-family: "Onesize";
    color: white;
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 1000;
}

#logout-button:hover {
    background-color: #bebbbb;
    color: #000000;
}

.map-button-container {
        position: absolute;
        top: 50px;
        right: 450px;
    }

    .button {
        background-color: #780606;
        border: 1px solid #6d6d6d;
        padding: 15px 20px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
    }


`;
/**
 * Represents the Canvas page
 */
export class CanvasComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /** Current game state */
    private _currentGameState?: DefaultGameState;
    /** Current active action button */
    private _selectedActionButton?: ActionReference;
    /** Current active game object buttons */
    private _selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshGameState();

        void this.refreshGameState();
        this.shadowRoot?.addEventListener("click", event => {
            if ((event.target as HTMLElement).id === "open-notebook") {
                this._gameEventService.switchPage(Page.Notebook);
            }
        });
        this.shadowRoot?.addEventListener("click", event => {
            if ((event.target as HTMLElement).id === "open-map") {
                this._gameEventService.switchPage(Page.wereldmap);
            }
        });
        this.shadowRoot?.addEventListener("click", event => {
            if ((event.target as HTMLElement).id === "open-map") {
                this._gameEventService.switchPage(Page.wereldmap);
            }
        });
    }

    /**
     * Refresh the current game state
     */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    /**
     * Update the canvas to the provided game state
     *
     * @param state Game state to update the canvas to
     */
    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Reset the component
        this._currentGameState = state;

        this._selectedActionButton = undefined;
        this._selectedGameObjectButtons.clear();

        // Refresh the web component
        this.render();
    }

    /**
     * Render the contents of this page
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
            <div class="inventory">
                <div class="inventory-header">
                ${this.renderInventoryName()}
                </div>
                <div class="inventory-items">
                <game-inventory></game-inventory>
                </div>
            </div>
           <div class="notebook-button-container">
    <button class="button" id="open-notebook">Notebook</button>
    <button class="button" id="open-map">Map</button>
</div>


           <div class="notebook-button-container">
    <button class="button" id="open-notebook">Notebook</button>
    <button class="button" id="open-map">Map</button>
</div>


             
            <div class="canvas">
                ${this.renderTitle()}
                ${this.renderHeader()}
                ${this.renderContent()}
                ${this.renderFooter()}
            </div>
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
        this.addEventListeners();
        this.checkloginstatus();
    }

    /**
     * Render the title element
     *
     * @returns String with raw HTML for the title element. Can be empty.
     */
    private renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;

        if (roomName) {
            return `<div class="title">${roomName}</div>`;
        }

        return "";
    }

    // private renderNotebook(): string {
    //     return `
    //     <div style="position: absolute; top: 10px; right: 10px;">
    //     </div>
    //     `;
    // }

    private renderInventoryName(): string {
        const inventoryName: string = "Inventory";
        return inventoryName;
    }

    /**
     * Render the header element
     *
     * @returns String with raw HTML for the header element. Can be empty.
     */
    private renderHeader(): string {
        const roomImages: string[] | undefined = this._currentGameState?.roomImages;

        if (roomImages && roomImages.length > 0) {
            return `
                <div class="header">
                        <button id="logout-button">Log out</button>
                    ${roomImages.map(url => `<img src="/assets/img/rooms/${url}.png" />`).join("")}
                </div>
            `;
        }

        return "";
    }

    /**
     * Render the content element
     *
     * @returns String with raw HTML for the content element
     */
    private renderContent(): string {
        return `
            <div class="content">
                ${this._currentGameState?.text.map(text => `<p>${text}</p>`).join("") || ""}
            </div>
        `;
    }

    /**
     * Render the footer element
     *
     * @returns HTML element of the footer
     */
    private renderFooter(): HTMLElement {
        return html`
            <div class="footer">
                <div class="buttons">
                    <div>
                        ${this._currentGameState?.actions.map(button => this.renderActionButton(button))}
                    </div>
                    <div>
                        ${this._selectedActionButton
                            ? this._currentGameState?.objects.map(button => this.renderGameObjectButton(button)) || ""
                            : ""
                        }
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * Render an action button for a given action reference
     *
     * @returns HTML element of the action button
     */
    private renderActionButton(button: ActionReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedActionButton === button ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickAction(button));

        return element;
    }

    /**
     * Render a game object button for a given game object reference
     *
     * @returns HTML element of the game object button
     */
    private renderGameObjectButton(button: GameObjectReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedGameObjectButtons.has(button) ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickGameObject(button));

        return element;
    }

    /**
     * Handle the click on an action button
     *
     * @param button Action button that was clicked
     */
    private async handleClickAction(button: ActionReference): Promise<void> {
        // If this actions needs a game object, show the available game objects.
        if (button.needsObject) {
            this._selectedActionButton = button;
            this._selectedGameObjectButtons.clear();

            this.render();

            return;
        }

        // Otherwise, execute the action and update the game state.
        const state: GameState | undefined = await this._gameRouteService.executeAction(button.alias);

        if (state === undefined) {
            return;
        }

        this.updateGameState(state);
    }

    /**
     * Handle the click on a game object button
     *
     * @param button Game object button that was clicked
     */
    private async handleClickGameObject(button: GameObjectReference): Promise<void> {
        // If no action button was clicked, do not try to handle this click.
        if (!this._selectedActionButton) {
            return;
        }

        // Add the game object to list of selected game objects
        this._selectedGameObjectButtons.add(button);

        // Try to execute the action with all game objects on the list
        const state: GameState | undefined = await this._gameRouteService.executeAction(
            this._selectedActionButton.alias,
            [...this._selectedGameObjectButtons].map(e => e.alias)
        );

        // If 2 more game objects where on the list, clear it.
        if (this._selectedGameObjectButtons.size >= 2) {
            this._selectedActionButton = undefined;
            this._selectedGameObjectButtons.clear();
        }

        // Refresh the web component
        this.render();

        // If no state was returned, exit silently. This can happen when an action needs more than 1 game object.
        if (state === undefined) {
            return;
        }

        // Otherwise, update the game state.
        this.updateGameState(state);
    }

    private addEventListeners(): void {
        const logoutButton: Element | null | undefined = this.shadowRoot?.querySelector("#logout-button");
        if (logoutButton) {
            logoutButton.addEventListener("click", () => this.logout());
        }
    }

    private logout(): void {
        const confirmation: boolean = confirm("Are you sure you want to log out?");
        if (confirmation) {
            localStorage.clear();
            console.log("Uitgelogd, localStorage is gewist.");
            window.location.reload();
        }
    }

    private checkloginstatus(): void {
        const logoutButton: HTMLElement | null = this.shadowRoot?.querySelector("#logout-button") as HTMLElement;
        const getlocalstorage: string | null = localStorage.getItem("userSession");
        if (getlocalstorage) {
            logoutButton.style.display = "block";
        }
        else {
            logoutButton.style.display = "none";
        }
        ;
    }
}
